import React, { useState } from "react";
import { Form, Title, Input, Label, Description } from "styles/common/FormStyle";
import { ButtonOutline } from "styles/common/ButtonStyle";
import { login } from "api/user";
import { Background, CommonWrapper } from "styles/common/Layout";
import { useNavigate } from "react-router-dom";
import useAuthStore from "store/auth";

function SignUp() {
  const navigate = useNavigate();
  const authStore = useAuthStore();

  const [form, setForm] = useState({
    userId: "",
    password: "",
  });

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const { userId, password } = form;
    try{
      const res = await login(userId, password);

      if (res?.token) {
        const token = res?.token;
        const user = res?.user;
        const refreshToken = res?.refreshToken;

        if (token && user && refreshToken){
          authStore?.login(user, token, refreshToken);
          navigate("/");
        }
      }

    }catch(error){
      alert(error);
    }
  };

  return (
    <Background>
      <CommonWrapper>
        <Form onSubmit={handleLogin}>
          <Title>로그인</Title>
          <Label htmlFor="userId">아이디</Label>
          <Input
            type="userId"
            id="userId"
            name="userId"
            value={form.userId}
            onChange={handleChange}
            placeholder="아이디를 입력해주세요."
          />
          <Label htmlFor="password">패스워드</Label>
          <Input
            type="password"
            id="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="비밀번호를 입력해주세요."
          />
          {/* <Label htmlFor="autoLogin">Auto Login</Label> */}
          {/* <Input
            type="checkbox"
            id="autoLogin"
            name="autoLogin"
            checked={form.autoLogin}
            onChange={handleChange}
          /> */}
          <ButtonOutline type="submit">Login</ButtonOutline>
        </Form>
        <Description>
          {/* <span onClick={() => navigate("/forgot/account")}>아이디 찾기</span> */}
          {/* | */}
          <span onClick={() => navigate("/account/forgot")}>계정 찾기</span>
          |
          <span onClick={() => navigate("/password/forgot")}>비밀번호 찾기</span>
          |
          <span onClick={() => navigate("/signup")}>회원가입</span>
        </Description>
      </CommonWrapper>
    </Background>
  );
}

export default SignUp;
